import { useEffect, useState } from "react";

/** Cycles bilingual subtitle lines (`cadence` ms each) over a playing film. */
export default function SubtitleStrip({ lines, active, testid, cadence = 7000 }) {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    setIdx(0);
    if (!active) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % lines.length), cadence);
    return () => clearInterval(t);
  }, [active, lines, cadence]);
  if (!active) return null;
  const line = lines[idx];
  return (
    <div className="absolute bottom-14 left-0 right-0 flex justify-center px-4 pointer-events-none" data-testid={testid}>
      <div key={idx} className="bg-[#02050F]/85 border border-white/10 rounded-lg px-4 py-2 text-center backdrop-blur-sm" style={{ animation: "d1-fade 0.5s both" }}>
        <div className="text-white text-sm font-semibold leading-snug">{line.hi}</div>
        <div className="text-[#00F0FF] text-xs">{line.en}</div>
      </div>
    </div>
  );
}
